/**
 * 对账的接口(S8)。一个 routeId,与 `apps/visual-game-server/src/routes/llm-admin/recon.js`
 * 的 `@callchain.routeId` 标注逐字对应。
 *
 * 返回形状(后端实测,`GET /reconciliation?since=…&until=…`):
 *   `{ items: Anomaly[], next_cursor: string|null, unpriceable: Unpriceable }`
 *
 * `items` 只包含供应商成本已落库、但积分结算或 ledger 核对未形成合法终态的成功调用。
 *
 * **`unpriceable` 是「成本事实未记录、所以无法判定是否零成本」的那些**,后端不将它们归入正常或异常,
 * 于是单独报条数。**口径是本页的候选行,不是整个时间区间的总数**(keyset 分页逐页给,后端不做全区间 COUNT)。
 *
 * @typedef {{ request_id: string, user_id: string|null, provider: string, model: string,
 *   billing_mode:string|null, supplier_cost_micros:number, currency:'CNY',
 *   expected_charged_points:number|null, ledger_id:string|null,
 *   created_at: string }} Anomaly
 * @typedef {{ count: number, supplier_cost_not_recorded: number }} Unpriceable
 */

import { llmHttp } from './http.js'

/**
 * 时间区间内、烧了 token 却没有计费行的调用。`since` / `until` 必填(`llm_call_log` 是按月分区的大表,
 * 不给区间就是让它扫全表),ISO 时间串。
 *
 * @callchain.routeId llm.admin.recon.list
 * @param {{ since: string, until: string, limit: number, cursor: string|null }} query
 * @returns {Promise<{ items: Anomaly[], next_cursor: string|null, unpriceable: Unpriceable }>}
 */
export function listUnbilledCalls(query) {
  return llmHttp().get('/reconciliation', { query, routeId: 'llm.admin.recon.list' })
}
